export const customStyles = {
  header: {
    style: {
      fontSize: '17px',
      fontWeight: 'bold',
      minHeight: '40px',
      paddingLeft: '16px',
      paddingRight: '8px'
    }
  },
  headRow: {
    style: {
      backgroundColor: '#637BFE',
      minHeight: '40px',
      borderRadius: '20px 20px 0 0',
      textAlign: 'left'
    }
  },
  headCells: {
    style: {
      color: '#FFFFFF',
      fontSize: '14px',
      fontWeight: 'bold',
      textAlign: 'left'
    }
  },
  rows: {
    style: {
      fontSize: '13px',
      fontFamily: ['Euclid Circular A', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(', '),
      fontWeight: 400,
      color: '#1E1E1E',
      minHeight: '70px',
      textAlign: 'left',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      verticalAlign: 'middle',
      '&:not(:last-of-type)': {
        borderBottomStyle: 'solid',
        borderBottomWidth: '0px'
      },
      '&:hover': {
        backgroundColor: '#f9fafc'
      }
    }
  },
  pagination: {
    style: {
      fontSize: '13px',
      minHeight: '50px',
      borderRadius: '0 0 20px 20px',
      textAlign: 'left'
    },
    pageButtonsStyle: {
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#B0B0B0',
        fill: '#5A5858'
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#EBF1FE'
      },
      '&:focus': {
        outline: 'none'
      }
    }
  }
}
